import React, { useEffect } from 'react';
import Divider from '@mui/material/Divider';
import { Outlet, useNavigate } from 'react-router-dom';
import LeftNav from './LeftNav';
import Header from './Header';
import useGetPartnerProfile from '../../../hooks/useGetPartnerProfile';
import { useOnboardingStore } from '../../../pages/Onboarding/store';
import { ONBOARDING_PAGE_TYPE } from '../../../pages/Onboarding/constants';
import AgreementBanner from '../AgreementGate/AgreementBanner';
import AgreementRequiredModal from '../AgreementGate/AgreementRequiredModal';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const { data, isFetchedAfterMount } = useGetPartnerProfile();
  const { setNextPage } = useOnboardingStore(({ setNextPage }) => ({ setNextPage }));
  const { kycStatus } = data?.data || {};

  useEffect(() => {
    // Decide only on a profile fetched since Layout mounted: a cached copy can predate the last
    // onboarding step (bank) and would log out a partner who has just finished onboarding.
    if (isFetchedAfterMount && kycStatus) {
      // With agreement e-sign on, a partner whose KYC is done but agreement is not yet e-signed
      // stays in the app (view-only) instead of being sent back to login.
      const awaitingEsignOnly = kycStatus?.agreementEsignEnabled && kycStatus?.kycCompleted;
      // Navigate to log in if partner onboarding incomplete
      if (!kycStatus?.onboardingCompleted && !awaitingEsignOnly) {
        setNextPage(ONBOARDING_PAGE_TYPE.PHONE_VERIFICATION);
        localStorage.removeItem('token');
        navigate('/login');
      }
    }
  }, [isFetchedAfterMount, kycStatus]);

  return (
    <div className="flex flex-col">
      <Divider sx={{ width: '100%' }} />
      <LeftNav />
      <Header />
      <div className="@container pl-4 pr-8 xl:ml-60" id="deal-detail-container">
        <AgreementBanner />
        {children ? children : <Outlet />}
      </div>
      <AgreementRequiredModal />
    </div>
  );
};

export default Layout;
